import { useSelector } from 'react-redux';
import useSmartNavigate from 'hooks/useSmartNavigate';
import useCustomer from 'hooks/useCustomer';
import { loadingStatus } from 'helpers/fetcher';
import Icon from 'components/Icon';

const STORE_ID_MOSCOW = 1;
const PAGE_DELIVERY_NALCHIK = '/page/15';
const PAGE_DELIVERY_MOSCOW = '/page/16';

const FooterLayout = () => {
	const { data, status } = useSelector(state => state.layout.mainInfo);
	const { navigate } = useSmartNavigate();
	const { customer } = useCustomer();
	const deliveryPage =
		customer?.store_id === STORE_ID_MOSCOW
			? PAGE_DELIVERY_MOSCOW
			: PAGE_DELIVERY_NALCHIK;

	return (
		<div
			className='rn-footer'
			style={{
				backgroundImage: `url(${
					process.env.PUBLIC_URL || ''
				}/images/bg-footer.webp)`,
				backgroundSize: 'cover',
				backgroundPosition: 'center',
				backgroundRepeat: 'no-repeat',
			}}
		>
			<div className='footer-content'>
				<div className='footer-main'>
					{/* Левая колонка */}
					<div className='footer-column footer-column-left'>
						<Icon
							name='logo'
							className='footer-logo'
							ariaLabel='РАЙЯН'
							ariaHidden={false}
						/>
						<p className='footer-subtitle'>Интернет-магазин</p>
						{status === loadingStatus.SUCCEEDED && data.telephone ? (
							<a href={`tel:${data.telephone}`} className='footer-phone'>
								{data.telephone}
							</a>
						) : (
							<a href='tel:+79182494242' className='footer-phone'>
								+7 (918) 249 42-42
							</a>
						)}
						<p className='footer-label'>Служба качества</p>
						{status === loadingStatus.SUCCEEDED && data.email_quality ? (
							<a href={`mailto:${data.email_quality}`} className='footer-email'>
								{data.email_quality}
							</a>
						) : (
							<a
								href='mailto:hygienequality@rayanhalal.ru'
								className='footer-email'
							>
								hygienequality@rayanhalal.ru
							</a>
						)}
					</div>

					{/* Колонки справа */}
					<div className='footer-columns-right'>
						{/* 2 колонка */}
						<div className='footer-column'>
							<ul className='footer-links'>
								<li>
									<a
										href='#'
										onClick={e => {
											e.preventDefault();
											navigate('/page/9');
										}}
										className='footer-link-bold'
									>
										Вакансии
									</a>
								</li>
								<li>
									<a
										href='#'
										onClick={e => {
											e.preventDefault();
											navigate('/contact');
										}}
									>
										Оставьте отзыв
									</a>
								</li>
								<li>
									<a
										href='#'
										onClick={e => {
											e.preventDefault();
											navigate('/news');
										}}
									>
										Новости
									</a>
								</li>
								<li>
									<a
										href='#'
										onClick={e => {
											e.preventDefault();
											navigate('/page/20');
										}}
									>
										Сертификаты
									</a>
								</li>
							</ul>
						</div>

						{/* 3 колонка */}
						<div className='footer-column'>
							<ul className='footer-links'>
								{/* Акции (временно скрыто)
								<li>
									<a
										href='#'
										onClick={e => {
											e.preventDefault();
											navigate('/page/promotions');
										}}
									>
										<Icon name='icon-percent-badge' className='footer-link-icon' />
										Акции
									</a>
								</li>
								*/}
								<li>
									<a
										href='#'
										onClick={e => {
											e.preventDefault();
											navigate('/page/4');
										}}
									>
										<Icon
											name='icon-info-circle'
											className='footer-link-icon'
										/>
										О компании
									</a>
								</li>
								<li>
									<a
										href='#'
										onClick={e => {
											e.preventDefault();
											navigate(deliveryPage);
										}}
									>
										<Icon
											name='icon-shipping-fast'
											className='footer-link-icon'
										/>
										Доставка и оплата
									</a>
								</li>
								<li>
									<a
										href='#'
										onClick={e => {
											e.preventDefault();
											navigate('/contact');
										}}
									>
										<Icon
											name='icon-envelope-footer'
											className='footer-link-icon'
										/>
										Контакты
									</a>
								</li>
							</ul>
						</div>

						{/* 4 колонка */}
						<div className='footer-column'>
							<ul className='footer-links'>
								<li>
									<a
										href='#'
										onClick={e => {
											e.preventDefault();
											navigate('/page/stores');
										}}
									>
										Магазины и кафе с нашей продукцией
									</a>
								</li>
								<li>
									<a
										href='#'
										onClick={e => {
											e.preventDefault();
											navigate('/page/6');
										}}
									>
										Как оплатить заказ
									</a>
								</li>
								<li>
									<a
										href='#'
										onClick={e => {
											e.preventDefault();
											navigate(deliveryPage);
										}}
									>
										Способ доставки
									</a>
								</li>
								<li>
									<a
										href='#'
										onClick={e => {
											e.preventDefault();
											navigate('/reviews');
										}}
									>
										Отзывы
									</a>
								</li>
							</ul>
						</div>
					</div>
				</div>

				{/* Иконки соцсетей и платежных систем */}
				<div className='footer-bottom'>
					<div className='footer-social'>
						<a href='#' className='footer-social-link'>
							<Icon name='Telegram' ariaLabel='Telegram' ariaHidden={false} />
						</a>
						<a href='#' className='footer-social-link'>
							<Icon name='VK' ariaLabel='VK' ariaHidden={false} />
						</a>
						<a href='#' className='footer-social-link'>
							<Icon name='WhatsApp' ariaLabel='WhatsApp' ariaHidden={false} />
						</a>
					</div>
					<div className='footer-payments'>
						<Icon
							name='Visa'
							className='footer-payment-icon'
							ariaLabel='Visa'
							ariaHidden={false}
						/>
						<Icon
							name='Mastercard'
							className='footer-payment-icon'
							ariaLabel='Mastercard'
							ariaHidden={false}
						/>
						<Icon
							name='mir'
							className='footer-payment-icon'
							ariaLabel='Mir'
							ariaHidden={false}
						/>
					</div>
				</div>
			</div>
		</div>
	);
};

export default FooterLayout;
